import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
import { WhatsNewUtils } from 'src/utils/whats-new.utils';
const WhatsNew = ({ onOverlayClick, content }) => {
    const [pageIndex, setPageIndex] = useState(0);
    const [images, setImages] = useState();
    const [ready, setReady] = useState(false);
    const locale = 'en'; // later use getUILanguage()
    useEffect(() => {
        const imgs = [];
        for (const feature of content.features[locale]) {
            const imageElement = new Image();
            imageElement.src = feature.image;
            imgs.push(imageElement);
        }
        setImages(imgs);
        imgs[0].onload = () => {
            setReady(true);
        };
    }, []);
    const next = () => {
        setPageIndex(pageIndex + 1);
    };
    const previous = () => {
        setPageIndex(pageIndex - 1);
    };
    const handleOnClick = (content, feature) => {
        if (feature.externalUrl) {
            chrome.tabs.create({ url: feature.externalUrl });
        }
        else {
            navigateToArticle(`${content.url}#${feature.anchor}`);
        }
    };
    const navigateToArticle = (url) => {
        chrome.tabs.create({ url: url });
    };
    const finish = () => {
        WhatsNewUtils.saveLastSeen();
        onOverlayClick();
    };
    const renderCustomIndicator = (clickHandler, isSelected, index, label) => {
        return (React.createElement("li", { className: `dot ${isSelected ? 'selected' : ''}`, onClick: (e) => {
                clickHandler(e);
                setPageIndex(index);
            } }));
    };
    if (!ready)
        return null;
    else
        return (React.createElement(PopupContainer, { "data-testid": "whats-new-popup", className: "whats-new" },
            React.createElement("div", { className: "popup-title" }, getMessage('popup_html_whats_new', [content.version])),
            images && (React.createElement(Carousel, { showArrows: false, showIndicators: content.features[locale].length > 1, selectedItem: pageIndex, showThumbs: false, showStatus: false, renderIndicator: renderCustomIndicator }, content.features[locale].map((feature, index) => {
                var _a;
                return (React.createElement("div", { className: "carousel-item", key: `feature-${index}` },
                    React.createElement("div", { className: "image" },
                        React.createElement("img", { src: images[index].src })),
                    React.createElement("div", { className: "title" }, feature.title),
                    React.createElement("div", { className: "description" }, feature.description),
                    React.createElement("div", { className: "extra-information" }, feature.extraInformation),
                    React.createElement("a", { "data-testid": "link-whats-new-read-more", className: "read-more-link", onClick: () => handleOnClick(content, feature) }, (_a = feature.overrideReadMoreLabel) !== null && _a !== void 0 ? _a : getMessage('html_popup_read_more'))));
            }))),
            React.createElement("div", { className: "popup-footer" },
                pageIndex > 0 && (React.createElement(ButtonComponent, { type: ButtonType.ALTERNATIVE, label: "popup_html_whats_new_previous", onClick: () => previous() })),
                pageIndex === content.features[locale].length - 1 && (React.createElement(ButtonComponent, { dataTestId: "button-last-page", type: ButtonType.IMPORTANT, label: "popup_html_whats_new_got_it", onClick: () => finish() })),
                pageIndex < content.features[locale].length - 1 && (React.createElement(ButtonComponent, { dataTestId: "button-next-page", type: ButtonType.ALTERNATIVE, label: "popup_html_whats_new_next", onClick: () => next() })))));
};
export const WhatsNewComponent = WhatsNew;
